<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--Sigla-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.Usuario_ID"
          label="Sigla Usuario:"
          hint="Digite Información"
          :rules="[rules.required]"
          dense
          :clearable="this.editedIndex != -1 ? false : true"
          :readonly="this.editedIndex != -1 ? true : false"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo de Usuario -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TipoUsuario"
          :items="
            ArrayTypeUser.map((x) => ({
              ...x,
              Valor: Number(x.Valor),
            }))
          "
          :item-title="
            (ArrayTypeUser) => ArrayTypeUser.Valor + '-' + ArrayTypeUser.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de Usuario: "
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Tipo de documento -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Type_Document"
          :items="
            ArrayTypeDocument.map((x) => ({
              ...x,
              Valor: Number(x.Valor),
            }))
          "
          :item-title="
            (ArrayTypeDocument) =>
              ArrayTypeDocument.Valor + '-' + ArrayTypeDocument.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de documento:"
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Documento -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Documento"
          label="Documento:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="tel"
          hint="Digite Información"
          :rules="[rules.required]"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Primer Nombre -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Nombre"
          label="Primer Nombre:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Segundo Nombre -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.SegundoNombre"
          label="Segundo Nombre:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Primer Apellido -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.PrimerApellido"
          label="Primer Apellido:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Segundo Apellido -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.SegundoApellido"
          label="Segundo Apellido:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Email -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.CorreoAutentificacion"
          label="Email:"
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
          :rules="[rules.required, rules.email]"
          :clearable="this.editedIndex != -1 ? false : true"
          :readonly="this.editedIndex != -1 ? true : false"
        >
        </v-text-field>
      </v-col>

      <!-- Celular -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Celular"
          label="Celular:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="tel"
          hint="Digite Información"
          :rules="[rules.required]"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Extension -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Extension"
          label="Extension:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="tel"
          hint="Digite Información"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Avatar -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Avatar"
          label="Avatar:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Estado -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Estado"
          :items="ArrayEstadoUser"
          :item-title="
            (ArrayEstadoUser) => ArrayEstadoUser.Valor + '-' + ArrayEstadoUser.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Estado:"
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Directorio Activo -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.DirectorioActivo_ID"
          :items="ArrayDirectory"
          :item-title="
            (ArrayDirectory) => ArrayDirectory.ID + '-' + ArrayDirectory.Descripcion
          "
          item-value="ID"
          color="primary"
          label="Directorio Activo:"
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Politíca de Seguridad -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.PoliticaSeguridad"
          :items="ArrayRules"
          :item-title="
            (ArrayRules) => ArrayRules.IdPolitica + '-' + ArrayRules.Descripcion
          "
          item-value="IdPolitica"
          color="primary"
          label="Política de Seguridad:"
          dense
          clearable
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Nivel Doble Factor: -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.NivelDobleFactor"
          :items="ArraySiNo"
          :item-title="(ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion"
          item-value="Valor"
          color="primary"
          label="Nivel Doble Factor:"
          :rules="[rules.required]"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { putUpdate, postInsert } from "@/views/TCI/Seguridad/Usuarios/UsuariosService";
import {
  EstadoUsuario,
  TablaSeleccion,
} from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";

export default {
  name: "datos-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Usuario_ID: null,
        TipoUsuario: null,
        Type_Document: null,
        Documento: null,
        Nombre: null,
        SegundoNombre: null,
        PrimerApellido: null,
        SegundoApellido: null,
        CorreoAutentificacion: null,
        Celular: null,
        Avatar: null,
        Extension: null,
        Estado: null,
        DirectorioActivo_ID: null,
        PoliticaSeguridad: null,
        NivelDobleFactor: "N",
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        UrlFront: null,
      },
      defaultItem: {
        Usuario_ID: null,
        TipoUsuario: null,
        Type_Document: null,
        Documento: null,
        Nombre: null,
        SegundoNombre: null,
        PrimerApellido: null,
        SegundoApellido: null,
        CorreoAutentificacion: null,
        Celular: null,
        Avatar: null,
        Extension: null,
        Estado: null,
        DirectorioActivo_ID: null,
        PoliticaSeguridad: null,
        NivelDobleFactor: "N",
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        UrlFront: null,
      },
      ArrayTypeUser: [],
      ArrayTypeDocument: [],
      ArrayEstadoUser: [],
      ArraySiNo: [],
      ArrayDirectory: [],
      ArrayRules: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UrlFront = `${window.location.origin}`;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      this.ArrayEstadoUser = Tables.filter(
        (item) => item.TablaId == TablaSeleccion.EstadoUser
      );

      this.ArraySiNo = Tables.filter((item) => item.TablaId == TablaSeleccion.SiNo);

      this.ArrayTypeUser = Tables.filter(
        (item) => item.TablaId == TablaSeleccion.TipoUser
      );

      this.ArrayTypeDocument = Tables.filter(
        (item) => item.TablaId == TablaSeleccion.TipoDocument
      );

      this.ArrayDirectory = this.$store.getters.MDirectoryActive;
      this.ArrayRules = this.$store.getters.MSecurityPolitic;
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
